import React from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {Typography, useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {BasicModalContent} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";
import {GridViewListTDAs} from "../../graphql/queries/gridViewListTDAs";
import {CreateGridView} from "../../graphql/mutations/createGridView";

interface Props {
    open: boolean,
    onClose?: () => void,
}

const CreateGridViewModal = ({onClose, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [createGridViewMutation] = useMutation(CreateGridView);

    const {data} = useQuery(GridViewListTDAs, {
        variables: {
            typeDefinitionIndex: "GRID_VIEW_CREATE"
        },
        fetchPolicy: "network-only",
    })

    const handleSubmit = (input: any) => {
        return createGridViewMutation({
                variables: {
                    input: input
                },
                refetchQueries: ["GridViewList"]
            }
        ).then((res) => {
            if (res.data?.createGridView?.id && res.data?.createGridView?.title) {
                toast.success(`${t("Successfully created grid view")} ${res.data?.createGridView?.title}`);
            } else {
                toast.error(t("Error creating grid view."))
            }
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
    }

    let attributes = _.get(data, 'gridViewList.typeDefinitionAttributeList.typeDefinitionAttributes', [])
    attributes = attributes.map((a: any) => {
        if (a.index === "rotationTime") {
            return {
                ...a,
                hint: t("Time in seconds how long each grid is displayed in loop mode"),
            }
        } else {
            return a
        }
    })

    return <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent onClose={onClose} title={<Typography level={'titleSmallLight'}>{t('Create a new Grid View')}</Typography>}>
            <InstalledBaseTDAForm
                formStyle={{paddingTop: '0px'}}
                onSubmit={handleSubmit}
                onCancel={onClose}
                submitButtonText={t('Create')}
                attributes={attributes}
            />
        </BasicModalContent>
    </Dialog>
};

export default CreateGridViewModal;
